export default __webpack_public_path__ + "resources/icons/d412-ac35.png";